<template>
    <div class="homeBody headerBg">
        <div class="width_total_100 animateContent homeAnimate1" style="height:100%">
            <div class="w_container">
                <div class="commonTop">
                  <span><img style="height:34px;margin-top:10px" src="../assets/img/logo.png"/></span>
                </div>
                <div class="bannerPart" style="padding-top:70px">
                    <div>
                        <div>大数据时代</div>
                        <p>让商业分析更高效，决策更科学！</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
            </div>
            <div class="footer">
                  <footer class="proFooter">
                        <img src="../assets/img/logo.png" />
                        <ul class="proConnect">
                            <li>
                                <span>咨询热线：</span>
                                <label>021-51791688-5057</label>
                            </li>
                            <li>
                                <span>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</span>
                                <label>dingjj@digiwin.com</label>
                            </li>
                            <li>
                                <span>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</span>
                                <label>上海市静安区江场路1377弄1号楼</label>
                            </li>
                        </ul>
                        <div class="proLink">
                            <span>友情链接：</span>
                            <ul>
                                <li><a href="https://www.digiwin.com/software/digiwinERP.html?utm_source=bdpz&utm_campain=biaoti" target="_blank">鼎捷数智</a></li>
                                <li><a href="https://market.digiwincloud.com.cn/" target="_blank">鼎捷云市场</a></li>
                                <li><a href="http://es-ygj.digiwincloud.com.cn/" target="_blank">鼎捷云管家</a></li>
                            </ul>
                            <div class="clear"></div>
                        </div>
                        <p>Copyright© 鼎捷数智股份有限公司. Copyright © Digiwin Datasys Co.,Ltd. All rights reserved.</p>
                  </footer>
            </div>
        </div>
        <div class="width_total_100 animateContent homeAnimate3">
            <div class="w_container" style="width:1144px">
            </div>
        </div>
        <ISVFreeTry :visible.sync="freeTryVisible"></ISVFreeTry>
    </div>
</template>
<script>
import "@/assets/css/w-style.css"

import Control from "@/components/common/Control.vue"
import FreeTryButton from "@/components/common/FreeTryButton.vue"
import ISVFreeTry from "@/components/common/ISVFreeTry.vue"

  export default {
    components: {
        Control,
        FreeTryButton,
        ISVFreeTry,
    },
    name: 'Home',
    data() {
      return {
        freeTryVisible: false
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Home',
            contentName : '',
            extend2: 'CN',
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error)
        });
    },
    mounted () {
        this.homeTopAnimate() // 顶部动画
    },
    methods: {
        homeTopAnimate() {
            var homeAnimate_show1=1;
            $(".homeBody").children(".animateContent").each(function() {
                if($(this).hasClass("homeAnimate1") &&  parseInt(homeAnimate_show1)){
                    homeAnimate_show1 = 0;
                    $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
                    $(this).find(".instruContent li").delay(800).addClass('flipInX animated hinge3');
                }
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        },
    }

  }
</script>
<style scoped>
.headerBg{
  background: url("../assets/img/product_bg.png") no-repeat center center;
}
.commonTop{
  text-align: left;
}
.footer {
  position: absolute;
  bottom: 200px;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
}
.proFooter {
  height: auto;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Manufacturer.vue